export enum BrandType {
  Unknown = 0,
  ShipleyEnergy = 1,
  Sauder = 3,
  CapitolCityOil = 4,
  KeystoneOil = 5,
  EnergyObjective = 6,
  SmartTouchEnergy = 7,
  HalyOil = 8,
  Emery = 9,
  Mauger = 10,
  AffordableOil = 11,
  StoweOil = 12,
  Pipeline = 13,
  YeagersFuel = 14,
}

export const GetBrandFullName = (brand: BrandType): string => brandNameMap.get(brand) ?? "Unknown";

const brandNameMap: Map<BrandType, string> = new Map<BrandType, string>([
  [BrandType.ShipleyEnergy, "Shipley Energy"],
  [BrandType.Sauder, "Sauder Fuel"],
  [BrandType.CapitolCityOil, "Capitol City Oil"],
  [BrandType.KeystoneOil, "Keystone Oil"],
  [BrandType.EnergyObjective, "Energy Objective"],
  [BrandType.SmartTouchEnergy, "Smart Touch Energy"],
  [BrandType.HalyOil, "Haly Oil"],
  [BrandType.Emery, "Emery"],
  [BrandType.Mauger, "Mauger"],
  [BrandType.AffordableOil, "Affordable Oil"],
  [BrandType.StoweOil, "Stowe Oil"],
  [BrandType.Pipeline, "Pipeline"],
  [BrandType.YeagersFuel, "Yeager's Fuel"],
]);
